import { TApplicationState } from '../../types/redux';
import { getHouses } from './getHouses';

export function getHasProblemsCurrentHouse(state: TApplicationState) {
  const houses = getHouses(state);
  const selectedHouseId = state.offers.selectedHouseId;

  if (selectedHouseId) {
    const selectedHouse = houses.find(house => house.houseId === selectedHouseId);

    return selectedHouse?.hasProblems || false;
  }

  return state.newbuilding.hasProblems;
}
